<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title DOCUMENTACION&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                  i.fas.fa-times
        .columns
          .column.is-3
            label.label Fecha de Entradas:
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-1.button-bottom
            a.button.is-black.is-rounded.is-small.is-top(@click="obtenerDocumentados")
              i.fas.fa-sync-alt
            | &nbsp
            a.button.is-danger.is-rounded.is-small.is-top(:href="lRep_DComp" target="_blank" v-show='verReporte &&!verNotificacion')
              i.fas.fa-print
          .column.is-offset-4.is-3
            .field
              label.label Filtrar
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='🔎 Buscar por PG | Fecha | Grupo | Subgrupo',
                  v-model="query_filter",
                )
        .columns(v-show="!verNotificacion")
          .column.is-12
            .table-responsive
              table#documentados.table.is-striped.is-fullwidth
                thead
                  tr
                    th.is-size-6
                      | Embarque
                    th.is-size-6 
                      | Autotanque
                    th.is-size-6 
                      | Registrado
                    th.is-size-6 
                      | Empresa
                    th.is-size-6 
                      | Grupo
                    th.is-size-6 
                      | Densidad Corr.
                tbody
                  tr(v-for="doc in documentadosSel" :key="doc.id")
                    td 
                      a.button.is-text(@click="editarEmbarque(doc)") {{ doc.numeroDeEmbarque }}
                      | &nbsp
                      a.button.is-black.is-rounded.is-small(@click="getLink(doc)")
                        span.icon
                          i.fas.fa-print
                    td {{ doc.pg }}
                    td {{ doc.fechaSalida }}
                    td(v-html="doc.companiaStr")
                    td(v-html="getGrupo(doc)")
                    td {{ doc.densidad}}
        .columns(v-show="verNotificacion")
          .column.is-12
            .notification
              |   No hay registros con éstos criterios de Búsqueda.
      .columns.column-blanco
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/irge/NavBarSca.vue'
  import sca_irgeServices from '@/services/sca/irge.js'
  import Loader from '@/components/shared/Loader.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'HomeDocumentacionIRGE',
    components: { NavBarSca, Loader, flatPickr },
    data() {
      return {
        isLoading: true,
        documentadosBD: [],
        query_filter: '',
        documentadosSel: [],
        fechaJornada: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        verNotificacion: false,
        isPropangolUser: false,
        isSiretracUser: false,
        lRep_DComp: '',
        verReporte: false,
      }
    },
    watch: {
      query_filter() {
        this.documentadosSel = []
        console.log(this.query_filter)
        const embFilter = this.documentadosBD.filter( emb => { 
          return `${emb.pg} ${emb.registrado} ${emb.grupo} ${emb.subgrupo} ${emb.noEmbarque}`.toUpperCase().includes(this.query_filter)
        }) 
        console.log(embFilter)
        this.documentadosSel = embFilter
        this.checkHayDatos()
      },
      fechaJornada () {
        this.obtenerDocumentados()
      }
    },
    methods: {
      iniciarComponente () {
        switch (this.userLogin.cargo) {
          case '888':
            this.isPropangolUser = true  
            this.verReporte = false
            break;
          case '345':
            this.isSiretracUser = true
            this.verReporte = true
            break
          default:
            this.isPropangolUser = false
            this.isSiretracUser = false
            this.verReporte = false
            break
        }
        this.obtenerDocumentados()
      },
      obtenerDocumentados () {
        this.documentadosSel = []
        sca_irgeServices.getDocumentados(this.fechaJornada)
          .then(data => {
            if (this.isPropangolUser) {
              this.documentadosBD = data.filter((emb) => emb.compania == "1" || emb.subgrupo == "gN" || emb.subgrupo == "gNM" || emb.compania == "3")
            } else {
              this.documentadosBD = data
            }
            this.documentadosSel = this.documentadosBD
            this.checkHayDatos()
          })
          .catch(e => console.log(e))
        this.isLoading = false
      },
      checkHayDatos () {
        if (this.documentadosSel.length < 1) {
          this.verNotificacion = true
          this.lRep_DComp = ''
        } else {
          this.verNotificacion = false
          this.getLinkReporte()
        }
      },
      getLinkReporte() {
        let currentUrl = window.location.hostname
        this.lRep_DComp = `http://10.122.40.189/servidores/reportes/IRGE_Documentadas.php?fecha=${this.fechaJornada}`
      },
      getGrupo(emp) {
        let html = ''
        const { grupoStr, subgrupoStr } = emp
        if (grupoStr === subgrupoStr) {
          html = `<span class="tag is-black">${grupoStr}</span>`
        } else {
          html = `<div class="control">
            <div class="tags has-addons">
              <span class="tag is-dark">${grupoStr}</span>
              <span class="tag is-primary">${subgrupoStr}</span>
            </div>
          </div>`
        }
        return html
      },
      
      getLink (emb) {
        const protocol = window.location.protocol
        const currentUrl = window.location.hostname
        this.link = `${protocol}//${currentUrl}/servidores/reportes/cartaPorte_Irge.php?emb=${emb.noEmbarque}&n=${emb.numeroDeEmbarque}`
        
        console.log(this.link)
        window.open(this.link, '_blank')
      },
      editarEmbarque (emb) {
        if (this.permisos.sca_irge == 7) {
          return
        }
        if (!this.isPropangolUser && !this.isSiretracUser) {
          console.log('No deben ser de propangol o siretrac')
          this.$store.commit('editarEmb_IRGE', emb)
          this.$router.push('/IRGE/SCA/Documentacion/Editar')
        } else {
          console.log('No deben entrar')
        }
      },
      backPage() {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .is-top {
    margin-top: 40px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/HomeDocumentacion.vue